import getSelectedLowestIndicativePrice from '../helpers/data-parsing/getSelectedLowestIndicativePrice';
import getSelectedMedianIndicativePrice from '../helpers/data-parsing/getSelectedMedianIndicativePrice';

import type { HotelsDatePricesState } from './types';

const getDateData = (state: HotelsDatePricesState) => state.dateData;
const isFetching = (state: HotelsDatePricesState) => state.isFetching;
const hasError = (state: HotelsDatePricesState) => state.error !== null;
const getError = (state: HotelsDatePricesState) => state.error;
const getCheapestPriceFromSelection = (
  state: HotelsDatePricesState,
  checkinDate: Date | null,
  checkoutDate: Date | null,
) =>
  getSelectedLowestIndicativePrice(checkinDate, checkoutDate, state.dateData);
const getTotalPriceFromSelection = (
  state: HotelsDatePricesState,
  checkinDate: Date,
  checkoutDate: Date,
) =>
  getSelectedMedianIndicativePrice(checkinDate, checkoutDate, state.dateData);

export default {
  getDateData,
  isFetching,
  hasError,
  getError,
  getCheapestPriceFromSelection,
  getTotalPriceFromSelection,
};
